

















































import _ from 'lodash'
import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import { Dictionary } from '@/types/general'
import { UI_SET_SIZE } from '@/store/ui/constants'
import { SETTINGS_LOAD_PREFERENCES } from '@/store/settings/constants'
import { Action, Mutation, State, Getter } from 'vuex-class'
import { RootState } from '@/store/types'
import { GroupedPreferences } from '@/store/settings/types'
import { UISize } from '@/store/ui/types'
import NPMPackage from '@/../package.json'
import { RouteBuilder } from '@/router'
import SettingsNavigation, { NavItem, NavSection } from './SettingsNavigation.vue'

const NAV_ITEMS: NavSection[] = [
    {
        title: 'User Preferences',
        items: [
            {
                icon: 'info',
                title: 'My Account',
                path: '/preferences/account'
            },
            {
                icon: 'key',
                title: 'My Keys',
                path: '/preferences/keys'
            },
            {
                icon: 'envelope',
                title: 'Notifications',
                path: '/preferences/notifications'
            },
            {
                icon: 'mobile',
                title: 'Devices',
                path: '/preferences/devices'
            }
        ]
    },
    {
        title: 'App Preferences',
        items: [
            {
                icon: 'browser',
                title: 'Interface',
                path: '/preferences/interface'
            },
            {
                icon: 'lock',
                title: 'Passwords',
                path: '/preferences/passwords'
            },
            {
                icon: 'shield-alt',
                title: 'Security',
                path: '/preferences/security'
            }
        ]
    },
    {
        title: 'Team Preferences',
        items: [
            {
                icon: 'users',
                title: 'Sharing',
                path: '/preferences/sharing'
            },
            {
                icon: 'briefcase',
                title: 'Organization',
                path: '/preferences/organization'
            }
        ]
    },
    {
        title: 'Tools',
        items: [
            {
                icon: 'cloud-upload',
                title: 'Import / Export',
                path: '/preferences/io'
            },
            {
                icon: 'trash',
                title: 'Trash',
                path: '/preferences/trash'
            }
        ]
    },
    {
        title: `Volt ${NPMPackage.version}`,
        items: [
            {
                icon: 'address-card',
                title: 'About',
                path: '/preferences/about'
            }
        ]
    }
]

@Component({ name: 'settings-page', components: { SettingsNavigation } })
export default class SettingsPage extends Vue {
    /**
     * Application version
     */
    version: string = NPMPackage.version

    /**
     * Page title
     */
    @Prop(String)
    title: string | undefined

    /**
     * Settings panel to display
     */
    @Prop(Function)
    component: Vue | undefined

    @Action(SETTINGS_LOAD_PREFERENCES)
    loadPreferences!: () => void

    /**
     * Update the global UI size
     */
    @Mutation(UI_SET_SIZE)
    setUISize!: (size: UISize) => void

    /**
     * Global interface size
     */
    @State((state: RootState) => state.ui.size)
    uiSize!: UISize

    @State((state: RootState) => state.settings.preferences)
    preferences!: Dictionary<GroupedPreferences>

    @State((state: RootState) => state)
    state!: RootState

    get stateRoute(): string {
        return RouteBuilder.getStateRoute(this.state)
    }

    @Getter
    usingPages!: boolean

    mounted(): void {
        if (_.isEmpty(this.preferences)) {
            this.loadPreferences()
        }
        if (!this.usingPages && !this.component) {
            this.$router.push('/preferences/account/')
        }
    }

    get navItems(): NavSection[] {
        return NAV_ITEMS
    }

    updateBreakpoints(applied: DOMTokenList): void {
        if (applied.contains('size-lg')) {
            if (this.uiSize !== 'lg-desktop') {
                this.setUISize('lg-desktop')
            }
        } else if (applied.contains('size-md')) {
            if (this.uiSize !== 'sm-desktop') {
                this.setUISize('sm-desktop')
            }
        } else if (applied.contains('size-sm')) {
            if (this.uiSize !== 'tablet') {
                this.setUISize('tablet')
            }
        } else if (this.uiSize !== 'mobile') {
            this.setUISize('mobile')
        }
        if (!this.usingPages && !this.component) {
            this.$router.push('/preferences/account/')
        }
    }
}
